module.exports = __webpack_public_path__ + "static/media/29BDOS26.281543c0.jpg";